import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import object from '@mailobj-browser/front/js/utils/object.js'

const missing = name => {
  throw new ReferenceError(`Missing ${name} plugin`)
}

const traps = object(null, {
  get: (refs, name) => refs[name] ?? missing(name)
})

const { window } = defaults
const {
  cordova = {},
  mailobj = {},
  plugins,
  FilePath,
  navigator,
  resolveLocalFileSystemURL
} = window
const badge = cordova?.plugins?.notification?.badge
const permissions = cordova?.plugins?.permissions
const printer = cordova?.plugins?.printer
const connection = { navigator }
const { file } = cordova
const intent = plugins?.intent
const shortcuts = mailobj?.plugin?.shortcuts

export const wrapper = object(null, {
  badge,
  connection,
  file,
  fs: resolveLocalFileSystemURL,
  intent,
  path: FilePath,
  permissions,
  printer,
  shortcuts
})

//export default new Proxy(wrapper, traps)
export default wrapper
